import React from 'react';
import HoverLabel from './hover-label';

class WholeChart extends React.Component {
  render() {
    const { item, hoverLabels } = this.props;
    const { colour = 'gray' } = item || {};

    return (
      <g>
        <circle cx={0} cy={0} r={350} stroke="transparent" strokeWidth="0" fill={colour} />
        <HoverLabel item={item} hoverLabels={hoverLabels} />
      </g>
    );
  }
}

WholeChart.defaultProps = {
  hoverLabels: false
};

export default WholeChart;
